// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__1fusd","title":"NotFound_title__D8KzW","message":"NotFound_message__obVKA","button":"NotFound_button__xf39Q"};